/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/mfa/verify`,
    // @ts-ignore for sm-axios
    urlTemplate: '/mfa/verify',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Verifies the MFA OTP. This should be called after the user-initiated the MFA register process, login or reset password.
 * 
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    /**
     * browser session JWT to identify the current user
     */
    token: string
    userDeviceToken: string
    /**
     * value could be otp or recovery code but recovery code is not supported at the moment
     */
    type: 'otp'
    code: string
  }
}

export interface Response {
  /**
   * is otp valid
   */
  valid: boolean
  /**
   * the number of requests remaining
   */
  rateLimitRemaining?: number
  /**
   * unix timestamp (seconds) of when verification can be attempted again. Only populated when rateLimitRemaining is 0.
   */
  nextAllowedTimestamp?: number
  /**
   * mfa request id that is saved in redis used for checking pan data
   */
  mfaRequestId?: string
}

